module.exports = __webpack_public_path__ + "static/media/team-member-jirona.64535741.jpg";